import React, { useEffect, useState } from "react";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import RTL from "../RTL/RTL";
import "Styles/layouts/_admin-layout.scss";
import { faMessages } from "Languages/locales/fa_IR";
import { enMessages } from "Languages/locales/en_US";
import { read } from "Helpers/LocalStorage";

const fa_fonts = `"IRANSans", "Tahoma", "BYekan", "B Yekan", "Sans Serif", monospace`;

function AdminLayout(props) {
  const [size, setSize] = useState(window.innerWidth);
  window.addEventListener("resize", () => {
    setSize(window.innerWidth);
  });

  const { rtlLayout } = useSelector((state) => ({
    rtlLayout: state.settings.rtlLayout,
  }));
  const theme = createTheme({
    direction: read('language_direction'),
  });

  useEffect(() => {
    const root = document.documentElement;
    // const fontFamily = getComputedStyle(root).getPropertyValue('--font-family');
    if (rtlLayout) {
      root.style.setProperty("--font-family", fa_fonts);
    } else {
      root.style.setProperty("--font-family", "Arial");
    }
  }, [rtlLayout]);

  // useEffect(() => {
  //   showDuplicates();
  //   showNotExistKey();
  // }, []);

  // const showNotExistKey = () => {
  //   let miss = [];
  //   const faobj = faMessages;
  //   const enobj = enMessages;
  //   // console.log('faMessages', Object.keys(faMessages).length);
  //   // console.log('enMessages', Object.keys(enMessages).length);
  //   for (let key in faobj) {
  //     if(!(key in enobj)) {
  //       miss.push(key);
  //     }
  //   }
  //   console.log(miss);
  // }


  // const showDuplicates = () => {
  //   let seen = {};
  //   let duplicates = {};
  //   const obj = faMessages;

  //   for (let key in obj) {
  //     const arr = [
  //       "saveNewMessage",
  //       "saveInvoiceDescription",
  //       "save",
  //       "sash_door",
  //       "sash",
  //       "sakht_groh_jadid",
  //       "same_source_and_destination",
  //       "sarboreshMolion",
  //       "sarboreshMolionKatibe",
  //       "sashDoor",
  //       "sabtena",
  //     ];
  //     if (key[0] !== "s" && key[1] !== "a" && !arr.includes(key)) {
  //       let value = obj[key];
  //       if (seen[value]) {
  //         if (!duplicates[value]) {
  //           duplicates[value] = [
  //             { key: seen[value].key, value: seen[value].value },
  //           ];
  //         }
  //         duplicates[value].push({ key: key, value: value });
  //       } else {
  //         seen[value] = { key: key, value: value };
  //       }
  //     }
  //   }

  //   //! ---- Print duplicates
  //   let i = 0;
  //   for (let value in duplicates) {
  //     console.log(`${++i} - duplicate key-value = ${value}`);
  //     duplicates[value].forEach((pair) => {
  //       console.log(
  //         `  [FA]: {${pair.key}: ${pair.value}} | [EN]: {${pair.key}: ${
  //           enMessages[pair.key]
  //         }}`,
  //         "en:",
  //         enMessages[pair.key] ? "-" : false
  //       );
  //     });
  //   }
  // };

  useEffect(() => {
    const setDisplayNone = () => {
      try {
        if (size <= 768) {
          const gr = document.getElementsByClassName("grecaptcha-badge");
          if (gr.length > 0) {
            Object.keys(gr).map((i) => {
              gr[i].style.display = "none";
            });
          }
        }
      } catch (err) {
        console.error("[catch error]", err);
      }
    };
    setTimeout(setDisplayNone, 0);
  }, []);

  return (
    <RTL>
      <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>
    </RTL>
  );
}

export default AdminLayout;
